import { createElement } from '@gn-audio/core/common/templating';
import './basket-coupon-list.component.scss';
import itemTempalte from './basket-coupon-list-item.template.html';
var BasketCouponListComponent = /** @class */ (function () {
    function BasketCouponListComponent() {
        var _this = this;
        this.items = [];
        this.buttonSelector = '.basket-coupon-code__list-item-button';
        this.onRemoveCoupon = function (event) {
            var targetCode = event.target.dataset.code;
            var coupon = _this.options.data.find(function (x) { return (x.code === targetCode); });
            _this.options.onRemove(coupon);
        };
    }
    BasketCouponListComponent.prototype.render = function (options) {
        this.options = options;
        options.container.classList.add('basket-coupon-code-list');
        for (var _i = 0, _a = this.options.data; _i < _a.length; _i++) {
            var coupon = _a[_i];
            var couponElement = options.container.appendChild(createElement(itemTempalte, coupon, options.translations));
            couponElement.querySelector(this.buttonSelector).addEventListener('click', this.onRemoveCoupon);
            this.items.push(couponElement);
        }
    };
    BasketCouponListComponent.prototype.destroy = function () {
        var _this = this;
        this.items.forEach(function (x) {
            x.querySelector(_this.buttonSelector)
                .removeEventListener('click', _this.onRemoveCoupon);
            x.remove();
        });
        this.items.length = 0;
    };
    return BasketCouponListComponent;
}());
export { BasketCouponListComponent };
